import { gql } from "@apollo/client";

export const findCommunicationTemplatesByBrandQuery = gql`
    query findCommunicationTemplatesByBrand($queryParams: QueryParams!) {
        findCommunicationTemplatesByBrand(queryParams: $queryParams, isManagerContext: true) {
            items {
                id
                friendlyId
                name
                description
                channel
                state
                emailSubject
                body
                createdAt
                updatedAt
                createdBy
                updatedBy
                teams {
                    id
                    name
                }
            }
            hasMore
            page
            pageSize
            total
        }
    }
`;
